import React, { useState } from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import InfoIcon from '../../assets/images/infoIcon.svg'
import * as styles from './shortHero.module.css'
import DownCaret from '../../assets/images/downcaretWhite.svg'

export default ({ title, subtitle, images, links }) => {
  // assume the strategy is random if not fixed
  // let image = images[Math.round(Math.random() * (images.length - 1))]
  const [displayMobileDesc, setMobileDescVisibility] = useState(false)
  const [image] = useState(
    images[Math.round(Math.random() * (images.length - 1))]
  )
  return (
    <div className={styles.hero}>
      <GatsbyImage
        image={image.gatsbyImageData}
        className={styles.heroImage}
        alt={image?.description} />
      <div className={styles.description}>{image.description}</div>
      <InfoIcon
        className={styles.infoIcon}
        onClick={() => setMobileDescVisibility(!displayMobileDesc)}
      />
      <div
        className={styles.mobileDescriptionBox}
        style={{ display: displayMobileDesc ? 'block' : 'none' }}
      >
        <div className={styles.mobileDescription}>{image.description}</div>
        <DownCaret className={styles.downCaret} />
      </div>

      <div className={styles.heroDetails}>
        <h2 className={styles.heroTitle}>{title}</h2>
        {subtitle != null && (
          <p className={styles.heroSubtitle}>{subtitle.subtitle}</p>
        )}
      </div>
    </div>
  );
}
